<template>
  <Toast/>
  <DialogConfirmation ref="dialogConfirmation"/>
  <div class="row">
    <div class="col">
      <DataTable
          class="p-datatable-sm"
          :value="natures"
          :resizableColumns="true"
          columnResizeMode="fit"
          :reorderableColumns="true"
          selectionMode="single"
          dataKey="cle"
          @row-select="onRowSelect"
          :paginator="true"
          :rows="10"
          sort-field="description"
          :sortOrder="1"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10, 30]"
          currentPageReportTemplate="Afficher {first} de {last} sur {totalRecords} classements"
      >
        <template #empty>
          <div v-if="isRechercheDataLoading == true" class="row">
            <div class="col">
              <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
            </div>
          </div>
          <div v-else class="row">
            &nbsp;&nbsp;&nbsp;Aucun enregistrement retourné
          </div>
        </template>
        <Column
            field="entiteDescription"
            header="Entité"
            :sortable="true"
        ></Column>
        <Column
            field="genreDescription"
            header="Genre"
            :sortable="true"
        ></Column>
        <Column
            field="description"
            header="Nature"
            :sortable="true"
        ></Column>
        <Column headerStyle="width: 3rem" :exportable="false">
          <template #body="slotProps">
            <Button
                icon="pi pi-trash"
                class="p-button-datatable p-button-sm"
                @click="confirmerSuppression(slotProps.data)"
            />
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script>
import DialogConfirmation from '../../Commun/DialogConfirmation.vue';

export default {
  props: ['natures', 'isRechercheDataLoading'],
  components: {
    DialogConfirmation
  },
  data() {
    return {
      natureASupprimer: null,
    }
  },
  methods: {
    confirmerSuppression(lien) {
      this.natureASupprimer = lien;
      this.$confirm.require({
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        message: "Voulez-vous supprimer cette nature?",
        accept: this.natureSupprimer,
        reject: () => {
        },
      })
    },
    natureSupprimer() {
      this.$store.dispatch('pilotage/supprimerTableValeurAction', {
        tableValeur: this.natureASupprimer
      });
    },
    onRowSelect(event) {
      this.$store.commit('pilotage/NATURE',event.data);
      this.$router.push({
        name: "modifierNature",
        params: {cle: event.data.cle},
      });
    },
  },
}
</script>
